var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "b-modal",
        {
          attrs: {
            id: "analytics-history-group-modal",
            title: "Group Management",
            centered: "",
            "no-close-on-backdrop": "",
            size: "lg",
            "ok-only": "",
            "ok-title": "Close",
            "ok-variant": "secondary",
          },
          on: { ok: _vm.onClose },
          model: {
            value: _vm.isOpened,
            callback: function ($$v) {
              _vm.isOpened = $$v
            },
            expression: "isOpened",
          },
        },
        [
          _c(
            "b-tabs",
            { ref: "groupTabs", attrs: { "content-class": "mt-3" } },
            [
              _c(
                "b-tab",
                {
                  attrs: {
                    title: "Create Group",
                    active: _vm.selectedTab === "create",
                  },
                  on: { click: _vm.onTabClick },
                },
                [
                  _c(
                    "div",
                    { attrs: { role: "group" } },
                    [
                      _c("label", { attrs: { for: "input-live" } }, [
                        _vm._v("Name of the Group:"),
                      ]),
                      _vm._v(" "),
                      _c("b-form-input", {
                        attrs: {
                          state: _vm.nameState,
                          disabled: _vm.isNameLoading,
                          placeholder: "Enter name",
                          "aria-describedby": "input-live-feedback",
                          trim: "",
                        },
                        model: {
                          value: _vm.name,
                          callback: function ($$v) {
                            _vm.name = $$v
                          },
                          expression: "name",
                        },
                      }),
                      _vm._v(" "),
                      _c(
                        "b-form-invalid-feedback",
                        { attrs: { id: "input-live-feedback" } },
                        [
                          _vm._v(
                            "\n            Enter a name of at least 1 and less than 255 chars.\n          "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.selectedIds.length > 0
                    ? _c(
                        "b-form-group",
                        { staticClass: "mt-2" },
                        [
                          _c("b", [_vm._v(_vm._s(_vm.selectedIds.length))]),
                          _vm._v(" reports selected\n          "),
                          _c(
                            "b-form-checkbox",
                            {
                              staticClass: "mt-2",
                              model: {
                                value: _vm.justCreate,
                                callback: function ($$v) {
                                  _vm.justCreate = $$v
                                },
                                expression: "justCreate",
                              },
                            },
                            [
                              _vm._v(
                                "\n            Create a new group without attaching reports\n          "
                              ),
                            ]
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "b-dropdown",
                    {
                      staticClass: "mt-2",
                      attrs: {
                        dropup: "",
                        split: "",
                        variant: "primary",
                        disabled: _vm.isNameLoading,
                      },
                      on: { click: _vm.create },
                      scopedSlots: _vm._u([
                        {
                          key: "button-content",
                          fn: function () {
                            return [
                              _vm.isNameLoading
                                ? _c("b-spinner", {
                                    staticClass: "mr-2",
                                    attrs: { small: "" },
                                  })
                                : _vm._e(),
                              _vm._v(
                                "\n            " +
                                  _vm._s(
                                    _vm.isNameLoading
                                      ? "Creating Group..."
                                      : "Create Group"
                                  ) +
                                  "\n          "
                              ),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    },
                    [
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "p-2" },
                        [
                          _vm._v(
                            "\n            If selected reports already belong to a group:\n            "
                          ),
                          _c("b-form-radio-group", {
                            staticClass: "mt-2",
                            staticStyle: { width: "250px" },
                            attrs: { options: _vm.addOptions, stacked: "" },
                            model: {
                              value: _vm.addAction,
                              callback: function ($$v) {
                                _vm.addAction = $$v
                              },
                              expression: "addAction",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-tab",
                {
                  attrs: {
                    title: "Manage Groups",
                    active: _vm.selectedTab === "manage",
                  },
                  on: { click: _vm.onTabClick },
                },
                [
                  _c(
                    "b-overlay",
                    { attrs: { show: _vm.isGroupsLoading, variant: "white" } },
                    [
                      _c(
                        "b-alert",
                        {
                          staticClass: "mt-3",
                          attrs: {
                            variant: "info",
                            show:
                              _vm.groups.length === 0 && !_vm.isGroupsLoading,
                            tex: "",
                          },
                        },
                        [
                          _c("p", { staticClass: "text-center" }, [
                            _vm._v(
                              "\n              No groups found. Create a new group to manage reports.\n            "
                            ),
                          ]),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "b-list-group",
                        _vm._l(_vm.groups, function (group) {
                          return _c(
                            "b-list-group-item",
                            {
                              key: group.id,
                              staticClass:
                                "cursor-pointer d-flex justify-content-between group-item",
                              attrs: { active: _vm.selectedGroup === group },
                              on: {
                                click: function ($event) {
                                  _vm.selectedGroup = group
                                },
                              },
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex align-items-center justify-content-start",
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(group.name) +
                                      " \n                "
                                  ),
                                  _c(
                                    "b-badge",
                                    {
                                      staticClass: "ml-2",
                                      attrs: { variant: "primary", pill: "" },
                                    },
                                    [
                                      _vm._v(
                                        "\n                  " +
                                          _vm._s(group.reports_count) +
                                          " \n                "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "group-item__buttons" },
                                [
                                  group.reports_count > 0
                                    ? _c(
                                        "b-button",
                                        {
                                          attrs: {
                                            size: "sm",
                                            variant: "outline-dark",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.stopPropagation()
                                              return _vm.showReportsInGroup(
                                                group
                                              )
                                            },
                                          },
                                        },
                                        [_c("i", { staticClass: "bi bi-eye" })]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-dark",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.rename(group)
                                        },
                                      },
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "bi bi-pencil-square",
                                      }),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "b-button",
                                    {
                                      attrs: {
                                        size: "sm",
                                        variant: "outline-danger",
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.stopPropagation()
                                          return _vm.deleteGroup(group.id)
                                        },
                                      },
                                    },
                                    [_c("i", { staticClass: "bi bi-trash" })]
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                      _vm._v(" "),
                      _vm.selectedIds.length > 0
                        ? _c(
                            "div",
                            [
                              _c("div", { staticClass: "mt-2" }, [
                                _c("b", [
                                  _vm._v(_vm._s(_vm.selectedIds.length)),
                                ]),
                                _vm._v(" reports selected\n            "),
                              ]),
                              _vm._v(" "),
                              _c(
                                "b-dropdown",
                                {
                                  staticClass: "mt-2",
                                  attrs: {
                                    id: "dropdown-dropup",
                                    dropup: "",
                                    split: "",
                                    text: "Add to selected Group",
                                    variant: "primary",
                                    disabled:
                                      !_vm.selectedGroup || _vm.isAttachLoading,
                                  },
                                  on: { click: _vm.attachToGroup },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "button-content",
                                        fn: function () {
                                          return [
                                            _vm.isAttachLoading
                                              ? _c("b-spinner", {
                                                  staticClass: "mr-2",
                                                  attrs: { small: "" },
                                                })
                                              : _vm._e(),
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(
                                                  _vm.isAttachLoading
                                                    ? "Adding to the group..."
                                                    : "Add to selected Group"
                                                ) +
                                                "\n              "
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    false,
                                    187971670
                                  ),
                                },
                                [
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "p-2" },
                                    [
                                      _vm._v(
                                        "\n                If selected reports already belong to a group:\n                "
                                      ),
                                      _c("b-form-radio-group", {
                                        staticClass: "mt-2",
                                        attrs: {
                                          options: _vm.attachOptions,
                                          name: "action",
                                          stacked: "",
                                        },
                                        model: {
                                          value: _vm.attachAction,
                                          callback: function ($$v) {
                                            _vm.attachAction = $$v
                                          },
                                          expression: "attachAction",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ]
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.totalPages > 1
                        ? _c("b-pagination", {
                            staticClass: "mt-3 mb-0",
                            attrs: {
                              align: "center",
                              "total-rows": _vm.totalItems,
                              "per-page": _vm.perPage,
                            },
                            on: { change: _vm.fetchGroups },
                            model: {
                              value: _vm.currentPage,
                              callback: function ($$v) {
                                _vm.currentPage = $$v
                              },
                              expression: "currentPage",
                            },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: { id: "rename-group-modal", title: "Rename", centered: "" },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function () {
                return [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "secondary" },
                      on: {
                        click: function ($event) {
                          return _vm.$bvModal.hide("rename-group-modal")
                        },
                      },
                    },
                    [_vm._v("\n        Cancel\n      ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-button",
                    {
                      attrs: {
                        variant: "primary",
                        disabled: _vm.isRenameLoading,
                        loading: _vm.isRenameLoading,
                      },
                      on: { click: _vm.handleRename },
                    },
                    [
                      _vm.isRenameLoading
                        ? _c("b-spinner", {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                          })
                        : _vm._e(),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.isRenameLoading ? "Renaming..." : "Rename"
                          ) +
                          "\n      "
                      ),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-form-input", {
            attrs: { disabled: _vm.isRenameLoading },
            model: {
              value: _vm.newName,
              callback: function ($$v) {
                _vm.newName = $$v
              },
              expression: "newName",
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          attrs: {
            id: "show-reports-in-group-modal",
            title: "Reports in Group",
            centered: "",
            "ok-only": "",
            "ok-title": "Close",
            "ok-variant": "secondary",
          },
          on: {
            ok: function ($event) {
              return _vm.$bvModal.hide("show-reports-in-group-modal")
            },
          },
        },
        [
          _vm.reportsInGroupTotalPages > 1
            ? _c("b-pagination", {
                attrs: {
                  "total-rows": _vm.reportsInGroupCount,
                  "per-page": _vm.reportsInGroupPerPage,
                },
                on: { change: _vm.fetchReportsInGroup },
                model: {
                  value: _vm.reportsInGroupPage,
                  callback: function ($$v) {
                    _vm.reportsInGroupPage = $$v
                  },
                  expression: "reportsInGroupPage",
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "b-alert",
            {
              staticClass: "mt-3",
              attrs: {
                variant: "info",
                show:
                  _vm.reportsInGroup.length === 0 && !_vm.reportsInGroupLoading,
              },
            },
            [_vm._v("\n      No reports found in this group.\n    ")]
          ),
          _vm._v(" "),
          _vm.reportsInGroup.length > 0
            ? _c(
                "b-table-simple",
                [
                  _c(
                    "b-thead",
                    [
                      _c(
                        "b-tr",
                        [
                          _c(
                            "b-th",
                            [
                              _c("b-checkbox", {
                                on: { change: _vm.handleSelectAllReports },
                                model: {
                                  value: _vm.selectAllReports,
                                  callback: function ($$v) {
                                    _vm.selectAllReports = $$v
                                  },
                                  expression: "selectAllReports",
                                },
                              }),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("b-th", [_vm._v("Report Name")]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.reportsInGroup, function (report) {
                    return _c(
                      "b-tr",
                      { key: report.id },
                      [
                        _c(
                          "b-td",
                          [
                            _c("b-checkbox", {
                              attrs: {
                                disabled: _vm.isAttachLoading,
                                value: report.id,
                              },
                              model: {
                                value: _vm.selectedReports,
                                callback: function ($$v) {
                                  _vm.selectedReports = $$v
                                },
                                expression: "selectedReports",
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("b-td", [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: report.report_link,
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(report.report_name) +
                                  " "
                              ),
                              _c("i", {
                                staticClass: "bi bi-box-arrow-up-right",
                              }),
                            ]
                          ),
                        ]),
                      ],
                      1
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.selectedReports.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "b-button",
                    {
                      staticClass: "mt-2",
                      attrs: {
                        variant: "primary",
                        disabled: _vm.isUnattachLoading,
                      },
                      on: { click: _vm.detachFromGroup },
                    },
                    [
                      _vm.isUnattachLoading
                        ? _c("b-spinner", {
                            staticClass: "mr-2",
                            attrs: { small: "" },
                          })
                        : _vm._e(),
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.isUnattachLoading
                              ? "Removing from the group..."
                              : "Remove selected reports from group"
                          ) +
                          "\n      "
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("b-overlay", {
            attrs: {
              show: _vm.reportsInGroupLoading,
              variant: "white",
              "no-wrap": "",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }